class StickyATC {
  constructor() {
    this.root = document.getElementById('StickyATC');
    if (!this.root) return;

    this.productForm = document.querySelector('product-form form');
    if (!this.productForm) return;

    this.price = this.root.querySelector('.sticky-atc__price');
    this.button = this.root.querySelector('.sticky-atc__button');
    this.variantSelect = this.root.querySelector('.sticky-atc__variant');

    this.footer = document.querySelector('.shopify-section-group-footer-group');

    this.variantInput = this.productForm.querySelector('[name="id"]');
    this.submitButton = this.productForm.querySelector('.product-form__submit');

    this.variants = JSON.parse(
      document.getElementById('StickyVariants').textContent
    );

    this.init();
  }

  init() {

    this.buildVariantSelect();

    this.bindVariantSelect();

    this.observe();

    this.bind();

    this.update();

    this.currentVariantId = this.variantInput.value;

    setInterval(() => {

      if (this.currentVariantId !== this.variantInput.value) {

        this.currentVariantId = this.variantInput.value;

        this.update();

      }

      // loadingクラス同期
      this.button.classList.toggle(
        'loading',
        this.submitButton.classList.contains('loading')
      );

      // spinner同期
      const mainSpinner = this.submitButton.querySelector('.loading__spinner');
      const stickySpinner = this.button.querySelector('.loading__spinner');

      if (mainSpinner && stickySpinner) {

        stickySpinner.classList.toggle(
          'hidden',
          mainSpinner.classList.contains('hidden')
        );

      }
    }, 100);

  }

  bind() {

    this.button.addEventListener('click', () => {
      this.submitButton.click();
    });

  }

  observe() {

    const check = () => {

      const rect = this.submitButton.getBoundingClientRect();

      const footerRect = this.footer?.getBoundingClientRect();

      const footerVisible =
        footerRect &&
        footerRect.top < window.innerHeight + 100;;

      this.root.classList.toggle(
        'is-visible',
        rect.top < 0 && !footerVisible
      );

    };

    check();

    window.addEventListener('scroll', check, {
      passive: true
    });

    window.addEventListener('resize', check);

  }

  update() {

    this.updatePrice();

    this.updateButton();

    this.syncVariantSelect();

  }

  updatePrice() {

    const price =
      document.querySelector('.price .price-item--regular') ||
      document.querySelector('.price');

    if (!price) return;

    this.price.innerHTML = price.innerHTML;

  }

  updateButton() {

    this.button.disabled =
      this.submitButton.disabled;

    const main =
      this.submitButton.querySelector('span');

    const sticky =
      this.button.querySelector('span');

    if (main && sticky) {

      sticky.innerHTML = main.innerHTML;

    }

  }

  buildVariantSelect() {

    const currentId = String(this.variantInput.value);

    this.variantSelect.innerHTML = this.variants
      .map(variant => `
        <option
          value="${variant.id}"
          ${currentId === String(variant.id) ? 'selected' : ''}
          ${variant.available ? '' : 'disabled'}>
          ${variant.option1} / ${variant.option2}${variant.available ? '' : ' (Sold out)'}
        </option>
      `)
      .join('');

  }


  bindVariantSelect() {

    this.variantSelect.addEventListener('change', () => {

      const variant = this.variants.find(
        v => String(v.id) === this.variantSelect.value
      );

      if (!variant) return;

      const colorRadio = document.querySelector(
        `variant-selects input[type="radio"][value="${CSS.escape(variant.option1)}"]`
      );

      if (colorRadio && !colorRadio.checked) {
        colorRadio.click();
      }

      requestAnimationFrame(() => {

        const sizeRadio = document.querySelector(
          `variant-selects input[type="radio"][value="${CSS.escape(variant.option2)}"]`
        );

        if (sizeRadio && !sizeRadio.checked) {
          sizeRadio.click();
        }

      });

    });

  }

  syncVariantSelect() {

    const id = String(this.variantInput.value);

    if (this.variantSelect.value !== id) {

      this.variantSelect.value = id;

    }

  }

  destroy() {

    this.observer.disconnect();
    clearInterval(this.syncTimer);

  }

}

document.addEventListener('DOMContentLoaded', () => {

  new StickyATC();

});